import React from "react";
import BoomIcon from "./BoomIcon";

export const boomIconNameOptions = [
  "add_circle-01.svg2",
  "alerts.svg2",
  "api_cog-01.svg2",
  "api_connections.svg2",
  "api_type-01.svg2",
  "arrow_right-01.svg2",
  "asset-01.svg2",
  "attach.svg2",
  "billing_overview.svg2",
  "bolt.svg2",
  "boom_calendar-01.svg2",
  "boomerang_element-01.svg2",
  "boomlocal-forward.svg2",
  "briefcase.svg2",
  "bulk_manage.svg2",
  "button_logic_ready.svg2",
  "cal_basic-01.svg2",
  "cal_event-01.svg2",
  "calendar.svg2",
  "chevon_down.svg2",
  "close.svg2",
  "cog.svg2",
  "comm_fields.svg2",
  "comms-delay.svg2",
  "componenets.svg2",
  "concat.svg2",
  "connections.svg2",
  "contact_edit.svg2",
  "contact_support.svg2",
  "contacts_main_nav.svg2",
  "contacts_main.svg2",
  "create_api_connection.svg2",
  "create_boomlogic.svg2",
  "create_broadcast.svg2",
  "create_inbound.svg2",
  "customers.svg2",
  "data_mapping-01.svg2",
  "docs.svg2",
  "edit-01.svg2",
  "edit.svg2",
  "engineer_visit.svg2",
  "engineer.svg2",
  "export.svg2",
  "features.svg2",
  "filter_solid.svg2",
  "filter.svg2",
  "free_build.svg2",
  "fulfilment.svg2",
  "global_settings.svg2",
  "groups_add.svg2",
  "groups.svg2",
  "hail.svg2",
  "humidity.svg2",
  "icon_1_way-01.svg2",
  "icon_2_way-01.svg2",
  "icon_activation_criteria-01.svg2",
  "icon_activation_keywords-01.svg2",
  "icon_address-01.svg2",
  "icon_api_endpoints-01.svg2",
  "icon_clicks-01.svg2",
  "icon_communications-01.svg2",
  "icon_contact_data_types-01.svg2",
  "icon_contacts-01.svg2",
  "icon_counter-01.svg2",
  "icon_data_variables-01.svg2",
  "icon_date_picker-01.svg2",
  "icon_date_time-01.svg2",
  "icon_distance-01.svg2",
  "icon_duration-01.svg2",
  "icon_email-01.svg2",
  "icon_group-01.svg2",
  "icon_inbound-01.svg2",
  "Icon_Library/application icons/api/data_mapping.svg2",
  "Icon_Library/application icons/api/icon_3rd_party_api.svg2",
  "Icon_Library/application icons/api/icon_advanced_settings.svg2",
  "Icon_Library/application icons/api/icon_business_hours.svg2",
  "Icon_Library/application icons/api/icon_data.svg2",
  "Icon_Library/application icons/api/icon_log_files.svg2",
  "Icon_Library/application icons/api/icon_logic_api.svg2",
  "Icon_Library/application icons/api/icon_message_api.svg2",
  "Icon_Library/application icons/api/icon_projects.svg2",
  "Icon_Library/application icons/api/icon_testing.svg2",
  "Icon_Library/application icons/api/icon_type_choose.svg2",
  "Icon_Library/application icons/api/icon_verify.svg2",
  "Icon_Library/application icons/api/import_side.svg2",
  "Icon_Library/application icons/api/overview.svg2",
  "Icon_Library/application icons/assets/asset_types/alert_building-01.svg2",
  "Icon_Library/application icons/assets/asset_types/alert_fire-01.svg2",
  "Icon_Library/application icons/assets/asset_types/alert_human_triggered-01.svg2",
  "Icon_Library/application icons/assets/asset_types/alert_it-01.svg2",
  "Icon_Library/application icons/assets/asset_types/alert_physical-01.svg2",
  "Icon_Library/application icons/assets/asset_types/alert_power-01.svg2",
  "Icon_Library/application icons/assets/asset_types/alert_stock-01.svg2",
  "Icon_Library/application icons/assets/asset_types/alert_traffic_transportation-01.svg2",
  "Icon_Library/application icons/assets/asset_types/alert_weather-01.svg2",
  "Icon_Library/application icons/assets/assets.svg2",
  "Icon_Library/application icons/assets/contacts_main.svg2",
  "Icon_Library/application icons/assets/events.svg2",
  "Icon_Library/application icons/assets/events/activate-01.svg2",
  "Icon_Library/application icons/assets/events/add_circle-01.svg2",
  "Icon_Library/application icons/assets/events/asset_events/asset.svg2",
  "Icon_Library/application icons/assets/events/asset_events/human-01.svg2",
  "Icon_Library/application icons/assets/events/asset_events/location_office-01.svg2",
  "Icon_Library/application icons/assets/events/asset_events/location_school-01.svg2",
  "Icon_Library/application icons/assets/events/asset_events/regional_office_hq-01.svg2",
  "Icon_Library/application icons/assets/events/asset_events/server-01.svg2",
  "Icon_Library/application icons/assets/events/asset_events/vehicle.svg2",
  "Icon_Library/application icons/assets/events/assets_contacts-01.svg2",
  "Icon_Library/application icons/assets/events/created_by-01.svg2",
  "Icon_Library/application icons/assets/events/details-01.svg2",
  "Icon_Library/application icons/assets/events/edit-01.svg2",
  "Icon_Library/application icons/assets/events/event_start_end_cal-.svg2",
  "Icon_Library/application icons/assets/events/event_type_alert-01.svg2",
  "Icon_Library/application icons/assets/events/event_type_event-01.svg2",
  "Icon_Library/application icons/assets/events/event_type_notification-01.svg2",
  "Icon_Library/application icons/assets/events/import_event-01.svg2",
  "Icon_Library/application icons/assets/events/layers/layer_bike-01.svg2",
  "Icon_Library/application icons/assets/events/layers/layer_traffic-01.svg2",
  "Icon_Library/application icons/assets/events/layers/layer_transit-01.svg2",
  "Icon_Library/application icons/assets/events/locations/location_office-01.svg2",
  "Icon_Library/application icons/assets/events/locations/location_school-01.svg2",
  "Icon_Library/application icons/assets/events/logic_project-01.svg2",
  "Icon_Library/application icons/assets/events/map_layers-01.svg2",
  "Icon_Library/application icons/assets/events/one_off_comms-01.svg2",
  "Icon_Library/application icons/assets/events/recipients-01.svg2",
  "Icon_Library/application icons/assets/events/remove-01.svg2",
  "Icon_Library/application icons/assets/events/send_method-01.svg2",
  "Icon_Library/application icons/assets/events/step_complete-01.svg2",
  "Icon_Library/application icons/assets/events/ticker_hide-01.svg2",
  "Icon_Library/application icons/assets/events/ticker_pause-01.svg2",
  "Icon_Library/application icons/assets/events/ticker-01.svg2",
  "Icon_Library/application icons/assets/events/ticket_details-01.svg2",
  "Icon_Library/application icons/assets/events/timeline-01.svg2",
  "Icon_Library/application icons/assets/events/types/type_fire-01.svg2",
  "Icon_Library/application icons/assets/events/types/type_terrorist-01.svg2",
  "Icon_Library/application icons/assets/events/types/type_traffic-01.svg2",
  "Icon_Library/application icons/assets/events/types/type_weather.svg2",
  "Icon_Library/application icons/assets/groups.svg2",
  "Icon_Library/application icons/assets/map_pin.svg2",
  "Icon_Library/application icons/assets/weather.svg2",
  "Icon_Library/application icons/billing/billing_details.svg2",
  "Icon_Library/application icons/billing/billing.svg2",
  "Icon_Library/application icons/billing/calendar_basic.svg2",
  "Icon_Library/application icons/billing/inbound_numbers.svg2",
  "Icon_Library/application icons/billing/invoices.svg2",
  "Icon_Library/application icons/billing/overview.svg2",
  "Icon_Library/application icons/billing/payment_methods.svg2",
  "Icon_Library/application icons/billing/postpaid.svg2",
  "Icon_Library/application icons/billing/status.svg2",
  "Icon_Library/application icons/dashboard/create_api_connection.svg2",
  "Icon_Library/application icons/dashboard/create_boomlogic.svg2",
  "Icon_Library/application icons/dashboard/create_broadcast.svg2",
  "Icon_Library/application icons/dashboard/create_inbound.svg2",
  "Icon_Library/application icons/dashboard/icon_3rd_party_api.svg2",
  "Icon_Library/application icons/dashboard/icon_logic_api.svg2",
  "Icon_Library/application icons/dashboard/icon_message_api.svg2",
  "Icon_Library/application icons/general/add_circle.svg2",
  "Icon_Library/application icons/general/alerts.svg2",
  "Icon_Library/application icons/general/api_type.svg2",
  "Icon_Library/application icons/general/arrow_right.svg2",
  "Icon_Library/application icons/general/attach.svg2",
  "Icon_Library/application icons/general/bolt.svg2",
  "Icon_Library/application icons/general/boom_calendar.svg2",
  "Icon_Library/application icons/general/boomlocal-forward.svg2",
  "Icon_Library/application icons/general/bulk_manage.svg2",
  "Icon_Library/application icons/general/button_logic_ready.svg2",
  "Icon_Library/application icons/general/cal_event.svg2",
  "Icon_Library/application icons/general/calendar.svg2",
  "Icon_Library/application icons/general/chevon_down.svg2",
  "Icon_Library/application icons/general/close.svg2",
  "Icon_Library/application icons/general/cog.svg2",
  "Icon_Library/application icons/general/comm_fields.svg2",
  "Icon_Library/application icons/general/comms-delay.svg2",
  "Icon_Library/application icons/general/concat.svg2",
  "Icon_Library/application icons/general/connections.svg2",
  "Icon_Library/application icons/general/contact_edit.svg2",
  "Icon_Library/application icons/general/contact_support.svg2",
  "Icon_Library/application icons/general/data_mapping.svg2",
  "Icon_Library/application icons/general/edit.svg2",
  "Icon_Library/application icons/general/engineer_visit.svg2",
  "Icon_Library/application icons/general/engineer.svg2",
  "Icon_Library/application icons/general/export.svg2",
  "Icon_Library/application icons/general/filter.svg2",
  "Icon_Library/application icons/general/free_build.svg2",
  "Icon_Library/application icons/general/fulfilment.svg2",
  "Icon_Library/application icons/general/groups_add.svg2",
  "Icon_Library/application icons/general/import_side.svg2",
  "Icon_Library/application icons/general/import.svg2",
  "Icon_Library/application icons/general/incident_report.svg2",
  "Icon_Library/application icons/general/info.svg2",
  "Icon_Library/application icons/general/ldap.svg2",
  "Icon_Library/application icons/general/manage_fields.svg2",
  "Icon_Library/application icons/general/mapping.svg2",
  "Icon_Library/application icons/general/marketing_fields.svg2",
  "Icon_Library/application icons/general/masking.svg2",
  "Icon_Library/application icons/general/message_recipients.svg2",
  "Icon_Library/application icons/general/messages_processed.svg2",
  "Icon_Library/application icons/general/messages.svg2",
  "Icon_Library/application icons/general/messenger.svg2",
  "Icon_Library/application icons/general/movable.svg2",
  "Icon_Library/application icons/general/num-status.svg2",
  "Icon_Library/application icons/general/num-validation.svg2",
  "Icon_Library/application icons/general/omni-channel.svg2",
  "Icon_Library/application icons/general/opt-in-out.svg2",
  "Icon_Library/application icons/general/originator.svg2",
  "Icon_Library/application icons/general/personal_details.svg2",
  "Icon_Library/application icons/general/plus.svg2",
  "Icon_Library/application icons/general/preview.svg2",
  "Icon_Library/application icons/general/print.svg2",
  "Icon_Library/application icons/general/prod_api.svg2",
  "Icon_Library/application icons/general/prod_boomlogic.svg2",
  "Icon_Library/application icons/general/prod_broadcast.svg2",
  "Icon_Library/application icons/general/prod_inbound.svg2",
  "Icon_Library/application icons/general/profile_fields.svg2",
  "Icon_Library/application icons/general/redo.svg2",
  "Icon_Library/application icons/general/reports_export.svg2",
  "Icon_Library/application icons/general/reports_generate.svg2",
  "Icon_Library/application icons/general/reports_saved.svg2",
  "Icon_Library/application icons/general/required_fields.svg2",
  "Icon_Library/application icons/general/satisfaction_survey.svg2",
  "Icon_Library/application icons/general/save.svg2",
  "Icon_Library/application icons/general/schedule_send.svg2",
  "Icon_Library/application icons/general/scheduling.svg2",
  "Icon_Library/application icons/general/search.svg2",
  "Icon_Library/application icons/general/secure_lock..svg2",
  "Icon_Library/application icons/general/self-manage.svg2",
  "Icon_Library/application icons/general/send.svg2",
  "Icon_Library/application icons/general/service_entries.svg2",
  "Icon_Library/application icons/general/shortlink.svg2",
  "Icon_Library/application icons/general/sla.svg2",
  "Icon_Library/application icons/general/sms_text.svg2",
  "Icon_Library/application icons/general/social_fb.svg2",
  "Icon_Library/application icons/general/social_li.svg2",
  "Icon_Library/application icons/general/social_x.svg2",
  "Icon_Library/application icons/general/social-hours.svg2",
  "Icon_Library/application icons/general/support_ticket.svg2",
  "Icon_Library/application icons/general/switch_refresh.svg2",
  "Icon_Library/application icons/general/system_usage.svg2",
  "Icon_Library/application icons/general/template_account.svg2",
  "Icon_Library/application icons/general/template_boomerang.svg2",
  "Icon_Library/application icons/general/template_helper.svg2",
  "Icon_Library/application icons/general/tick_circled.svg2",
  "Icon_Library/application icons/general/tick_list.svg2",
  "Icon_Library/application icons/general/tick.svg2",
  "Icon_Library/application icons/general/timezones.svg2",
  "Icon_Library/application icons/general/undo.svg2",
  "Icon_Library/application icons/general/unicode.svg2",
  "Icon_Library/application icons/general/unrec-response.svg2",
  "Icon_Library/application icons/general/upgrades.svg2",
  "Icon_Library/application icons/general/upload_file-01.svg2",
  "Icon_Library/application icons/general/upload.svg2",
  "Icon_Library/application icons/general/user_group.svg2",
  "Icon_Library/application icons/general/web-forms.svg2",
  "Icon_Library/application icons/general/whatsapp.svg2",
  "Icon_Library/application icons/general/xls_files.svg2",
  "Icon_Library/application icons/interactions/interactions.svg2",
  "Icon_Library/application icons/library/api_data_connections.svg2",
  "Icon_Library/application icons/library/api_profiles.svg2",
  "Icon_Library/application icons/library/boomAI_icon_white.svg2",
  "Icon_Library/application icons/library/boomAI_icon.svg2",
  "Icon_Library/application icons/library/contacts_main.svg2",
  "Icon_Library/application icons/library/icon_translate.svg2",
  "Icon_Library/application icons/library/library_broadcast.svg2",
  "Icon_Library/application icons/library/library_documents.svg2",
  "Icon_Library/application icons/library/library_logic.svg2",
  "Icon_Library/application icons/library/library.svg2",
  "Icon_Library/application icons/library/solutions.svg2",
  "Icon_Library/application icons/library/weather.svg2",
  "Icon_Library/application icons/menus/main navigation/boomerang_element-01.svg2",
  "Icon_Library/application icons/menus/main navigation/logout.svg2",
  "Icon_Library/application icons/menus/main navigation/nav_assets.svg2",
  "Icon_Library/application icons/menus/main navigation/nav_billing.svg2",
  "Icon_Library/application icons/menus/main navigation/nav_contacts.svg2",
  "Icon_Library/application icons/menus/main navigation/nav_dashboard.svg2",
  "Icon_Library/application icons/menus/main navigation/nav_interactions.svg2",
  "Icon_Library/application icons/menus/main navigation/nav_monitoring.svg2",
  "Icon_Library/application icons/menus/main navigation/nav_reports.svg2",
  "Icon_Library/application icons/menus/main navigation/nav_settings.svg2",
  "Icon_Library/application icons/menus/main navigation/nav_templates.svg2",
  "Icon_Library/application icons/menus/top navigation/chevon_down.svg2",
  "Icon_Library/application icons/menus/top navigation/docs.svg2",
  "Icon_Library/application icons/menus/top navigation/info.svg2",
  "Icon_Library/application icons/menus/top navigation/live_chat.svg2",
  "Icon_Library/application icons/menus/top navigation/menu.svg2",
  "Icon_Library/application icons/monitoring/alerts_notifications-01.svg2",
  "Icon_Library/application icons/monitoring/check_tick-01.svg2",
  "Icon_Library/application icons/monitoring/configuration-01.svg2",
  "Icon_Library/application icons/monitoring/icon_alert.svg2",
  "Icon_Library/application icons/monitoring/icon_heartbeat_1.svg2",
  "Icon_Library/application icons/monitoring/icon_heartbeat_2.svg2",
  "Icon_Library/application icons/monitoring/icon_ping .svg2",
  "Icon_Library/application icons/monitoring/industries/industry_construction-01.svg2",
  "Icon_Library/application icons/monitoring/map_view-01.svg2",
  "Icon_Library/application icons/monitoring/monitor_types/mon_environmental_conditions-01.svg2",
  "Icon_Library/application icons/monitoring/monitor_types/mon_remote_devices-01.svg2",
  "Icon_Library/application icons/monitoring/monitor_types/mon_weather.svg2",
  "Icon_Library/application icons/monitoring/monitor_types/mon_welfare-01.svg2",
  "Icon_Library/application icons/monitoring/monitoring-01.svg2",
  "Icon_Library/application icons/monitoring/monitors_overview-01.svg2",
  "Icon_Library/application icons/monitoring/save-01.svg2",
  "Icon_Library/application icons/monitoring/select_workflow-01.svg2",
  "Icon_Library/application icons/monitoring/setup-01.svg2",
  "Icon_Library/application icons/monitoring/view_manage_monitors-01.svg2",
  "Icon_Library/application icons/reports/assets.svg2",
  "Icon_Library/application icons/reports/billing.svg2",
  "Icon_Library/application icons/reports/features.svg2",
  "Icon_Library/application icons/reports/messaging_data.svg2",
  "Icon_Library/application icons/reports/process_reports.svg2",
  "Icon_Library/application icons/reports/realtime_reporting.svg2",
  "Icon_Library/application icons/reports/reporting_analytical.svg2",
  "Icon_Library/application icons/reports/reporting_system.svg2",
  "Icon_Library/application icons/reports/reports.svg2",
  "Icon_Library/application icons/reports/tiket_reporting.svg2",
  "Icon_Library/application icons/reports/workflows.svg2",
  "Icon_Library/application icons/settings/comms_defaults.svg2",
  "Icon_Library/application icons/settings/communications.svg2",
  "Icon_Library/application icons/settings/company.svg2",
  "Icon_Library/application icons/settings/invoices.svg2",
  "Icon_Library/application icons/settings/organisation.svg2",
  "Icon_Library/application icons/settings/security.svg2",
  "Icon_Library/application icons/settings/settings.svg2",
  "Icon_Library/application icons/settings/sms_settings.svg2",
  "Icon_Library/application icons/settings/status.svg2",
  "Icon_Library/application icons/settings/timezones.svg2",
  "Icon_Library/application icons/settings/users_roles.svg2",
  "Icon_Library/application icons/settings/users.svg2",
  "Icon_Library/application icons/weather/codes_conditions/clear_sky-01.svg2",
  "Icon_Library/application icons/weather/codes_conditions/cloudy-01.svg2",
  "Icon_Library/application icons/weather/codes_conditions/drizzle-01.svg2",
  "Icon_Library/application icons/weather/codes_conditions/fog-01.svg2",
  "Icon_Library/application icons/weather/codes_conditions/heavy_rain_shower-01.svg2",
  "Icon_Library/application icons/weather/codes_conditions/heavy_rain-01.svg2",
  "Icon_Library/application icons/weather/codes_conditions/heavy_snow_shower-01.svg2",
  "Icon_Library/application icons/weather/codes_conditions/heavy_snow-01.svg2",
  "Icon_Library/application icons/weather/codes_conditions/light_rain_shower-01.svg2",
  "Icon_Library/application icons/weather/codes_conditions/light_rain-01.svg2",
  "Icon_Library/application icons/weather/codes_conditions/light_snow_shower-01.svg2",
  "Icon_Library/application icons/weather/codes_conditions/light_snow-01.svg2",
  "Icon_Library/application icons/weather/codes_conditions/max_screen_temp-01.svg2",
  "Icon_Library/application icons/weather/codes_conditions/min_screen_temp-01.svg2",
  "Icon_Library/application icons/weather/codes_conditions/mist-01.svg2",
  "Icon_Library/application icons/weather/codes_conditions/overcast-01.svg2",
  "Icon_Library/application icons/weather/codes_conditions/partly_cloudy-01.svg2",
  "Icon_Library/application icons/weather/codes_conditions/probability_of_snow_visibility-01.svg2",
  "Icon_Library/application icons/weather/codes_conditions/significant_weather-01.svg2",
  "Icon_Library/application icons/weather/codes_conditions/sleet_shower-01.svg2",
  "Icon_Library/application icons/weather/codes_conditions/sleet-01.svg2",
  "Icon_Library/application icons/weather/codes_conditions/sunny-01.svg2",
  "Icon_Library/application icons/weather/codes_conditions/thunder_shower-01.svg2",
  "Icon_Library/application icons/weather/codes_conditions/thunder-01.svg2",
  "Icon_Library/application icons/weather/codes_conditions/wind_direction.svg2",
  "Icon_Library/application icons/weather/codes_conditions/wind_speed-01.svg2",
  "Icon_Library/application icons/weather/map_markers/hail.svg2",
  "Icon_Library/application icons/weather/map_markers/humidity.svg2",
  "Icon_Library/application icons/weather/map_markers/lightning.svg2",
  "Icon_Library/application icons/weather/map_markers/precipitation.svg2",
  "Icon_Library/application icons/weather/map_markers/pressure.svg2",
  "Icon_Library/application icons/weather/map_markers/rain.svg2",
  "Icon_Library/application icons/weather/map_markers/snow.svg2",
  "Icon_Library/application icons/weather/map_markers/temperature.svg2",
  "Icon_Library/application icons/weather/map_markers/uv.svg2",
  "Icon_Library/application icons/weather/map_markers/visibility.svg2",
  "Icon_Library/application icons/weather/map_markers/wind_direction.svg2",
  "Icon_Library/application icons/weather/weather.svg2",
  "Icon_Library/cube icons/account_template-01.svg2",
  "Icon_Library/cube icons/activation_opt_ins-01.svg2",
  "Icon_Library/cube icons/active_groups.svg2",
  "Icon_Library/cube icons/add_edit_contacts-01.svg2",
  "Icon_Library/cube icons/aggregate_responses-01.svg2",
  "Icon_Library/cube icons/aggregate-01.svg2",
  "Icon_Library/cube icons/ai_conversations-01.svg2",
  "Icon_Library/cube icons/ai_management-01.svg2",
  "Icon_Library/cube icons/alerts_notifcations-01.svg2",
  "Icon_Library/cube icons/analytical_reporting-01.svg2",
  "Icon_Library/cube icons/api_connections-01.svg2",
  "Icon_Library/cube icons/assets-01.svg2",
  "Icon_Library/cube icons/attachments.svg2",
  "Icon_Library/cube icons/boomerang_template-01.svg2",
  "Icon_Library/cube icons/boomlogic_projects-01.svg2",
  "Icon_Library/cube icons/broadcast-01.svg2",
  "Icon_Library/cube icons/bulk_manage-01.svg2",
  "Icon_Library/cube icons/comms_delay-01.svg2",
  "Icon_Library/cube icons/connections-01.svg2",
  "Icon_Library/cube icons/contacts-01.svg2",
  "Icon_Library/cube icons/count_collate_data-01.svg2",
  "Icon_Library/cube icons/data_analysis-01.svg2",
  "Icon_Library/cube icons/data_overwrite-01.svg2",
  "Icon_Library/cube icons/delay_send-01.svg2",
  "Icon_Library/cube icons/delivery_statuses-01.svg2",
  "Icon_Library/cube icons/export_reports-01.svg2",
  "Icon_Library/cube icons/filtering-01.svg2",
  "Icon_Library/cube icons/freebuild-01.svg2",
  "Icon_Library/cube icons/generate_reports-01.svg2",
  "Icon_Library/cube icons/groups-01.svg2",
  "Icon_Library/cube icons/import-01.svg2",
  "Icon_Library/cube icons/inbound_campaign-01.svg2",
  "Icon_Library/cube icons/inbound_numbers-01.svg2",
  "Icon_Library/cube icons/invoices-01.svg2",
  "Icon_Library/cube icons/knowledgebase-01.svg2",
  "Icon_Library/cube icons/logic_components_library-01.svg2",
  "Icon_Library/cube icons/map_pin-01.svg2",
  "Icon_Library/cube icons/mapping-01.svg2",
  "Icon_Library/cube icons/marketing_fields-01.svg2",
  "Icon_Library/cube icons/masking-01.svg2",
  "Icon_Library/cube icons/matched_replies-01.svg2",
  "Icon_Library/cube icons/number_status-01.svg2",
  "Icon_Library/cube icons/number_validation-01.svg2",
  "Icon_Library/cube icons/omni_channel-01.svg2",
  "Icon_Library/cube icons/paymnet_methods-01.svg2",
  "Icon_Library/cube icons/preview-01.svg2",
  "Icon_Library/cube icons/process_reports-01.svg2",
  "Icon_Library/cube icons/progress_saving-01.svg2",
  "Icon_Library/cube icons/real_time_reporting-01.svg2",
  "Icon_Library/cube icons/replies-01.svg2",
  "Icon_Library/cube icons/reporting-01.svg2",
  "Icon_Library/cube icons/saved_reports-01.svg2",
  "Icon_Library/cube icons/schedule_send-01.svg2",
  "Icon_Library/cube icons/security-01.svg2",
  "Icon_Library/cube icons/service_entries-01.svg2",
  "Icon_Library/cube icons/service_usage-01.svg2",
  "Icon_Library/cube icons/settings-01.svg2",
  "Icon_Library/cube icons/shortlinks-01.svg2",
  "Icon_Library/cube icons/sla-01.svg2",
  "Icon_Library/cube icons/social_hours-01.svg2",
  "Icon_Library/cube icons/system_reporting-01.svg2",
  "Icon_Library/cube icons/template_library-01.svg2",
  "Icon_Library/cube icons/template_qanda-01.svg2",
  "Icon_Library/cube icons/ticketing_reports-01.svg2",
  "Icon_Library/cube icons/timezones-01.svg2",
  "Icon_Library/cube icons/unmatched_replies-01.svg2",
  "Icon_Library/cube icons/unrec_responses-01.svg2",
  "Icon_Library/cube icons/upgrades-01.svg2",
  "Icon_Library/cube icons/user_access_controls-01.svg2",
  "Icon_Library/cube icons/variable_data-01.svg2",
  "Icon_Library/cube icons/web_forms-01.svg2",
  "Icon_Library/cube icons/weighting-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_app_booking_reminders-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_app_booking_rescheduling-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_asset_tracking-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_booking_requests-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_business_continuity_comms-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_collection_reminders-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_contact_center_eng-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_contact_center_ivr-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_contact_management-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_customer_initiated_engagement-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_debt_recovery-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_doc_workflow-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_environmental_monitoring-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_field_force_comms-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_field_force_scheduling-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_inbound_marketing-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_incident_management-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_info_requests-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_instant_auth-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_iot_monitoring-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_it_monitoring_alerting-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_lone_worker-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_machine_2_machine-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_marketing_campaigns-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_membership_sub_management-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_mustering-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_opt_in_opt_out_management-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_order_delivery_management-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_payment_reminders-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_resource_managment_fulfilment-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_service_desk_ticketing-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_service_sla-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_shift_planning-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_sub_renewals-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_survey_sms-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_survey_web-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_traffic_alerts-01.svg2",
  "Icon_Library/solutions icons/app_colouring/sol_weather_alerts-01.svg2",
  "Icon_Library/solutions icons/sol_app_booking_reminders-01.svg2",
  "Icon_Library/solutions icons/sol_app_booking_rescheduling-01.svg2",
  "Icon_Library/solutions icons/sol_asset_tracking-01.svg2",
  "Icon_Library/solutions icons/sol_booking_requests-01.svg2",
  "Icon_Library/solutions icons/sol_business_continuity_comms-01.svg2",
  "Icon_Library/solutions icons/sol_collection_reminders-01.svg2",
  "Icon_Library/solutions icons/sol_contact_center_eng-01.svg2",
  "Icon_Library/solutions icons/sol_contact_center_ivr-01.svg2",
  "Icon_Library/solutions icons/sol_contact_management-01.svg2",
  "Icon_Library/solutions icons/sol_customer_initiated_engagement-01.svg2",
  "Icon_Library/solutions icons/sol_debt_recovery-01.svg2",
  "Icon_Library/solutions icons/sol_doc_workflow-01.svg2",
  "Icon_Library/solutions icons/sol_environmental_monitoring-01.svg2",
  "Icon_Library/solutions icons/sol_field_force_comms-01.svg2",
  "Icon_Library/solutions icons/sol_field_force_scheduling-01.svg2",
  "Icon_Library/solutions icons/sol_inbound_marketing-01.svg2",
  "Icon_Library/solutions icons/sol_incident_management-01.svg2",
  "Icon_Library/solutions icons/sol_info_requests-01.svg2",
  "Icon_Library/solutions icons/sol_instant_auth-01.svg2",
  "Icon_Library/solutions icons/sol_iot_monitoring-01.svg2",
  "Icon_Library/solutions icons/sol_it_monitoring_alerting-01.svg2",
  "Icon_Library/solutions icons/sol_lone_worker-01.svg2",
  "Icon_Library/solutions icons/sol_machine_2_machine-01.svg2",
  "Icon_Library/solutions icons/sol_marketing_campaigns-01.svg2",
  "Icon_Library/solutions icons/sol_membership_sub_management-01.svg2",
  "Icon_Library/solutions icons/sol_mustering-01.svg2",
  "Icon_Library/solutions icons/sol_opt_in_opt_out_management-01.svg2",
  "Icon_Library/solutions icons/sol_order_delivery_management-01.svg2",
  "Icon_Library/solutions icons/sol_payment_reminders-01.svg2",
  "Icon_Library/solutions icons/sol_resource_managment_fulfilment-01.svg2",
  "Icon_Library/solutions icons/sol_service_desk_ticketing-01.svg2",
  "Icon_Library/solutions icons/sol_service_sla-01.svg2",
  "Icon_Library/solutions icons/sol_shift_planning-01.svg2",
  "Icon_Library/solutions icons/sol_sub_renewals-01.svg2",
  "Icon_Library/solutions icons/sol_survey_sms-01.svg2",
  "Icon_Library/solutions icons/sol_survey_web-01.svg2",
  "Icon_Library/solutions icons/sol_traffic_alerts-01.svg2",
  "Icon_Library/solutions icons/sol_weather_alerts-01.svg2",
  "icon_mobile_number-01.svg2",
  "icon_rcs-01.svg2",
  "icon_recipients-01.svg2",
  "icon_repeat-01.svg2",
  "icon_replies-01.svg2",
  "icon_reporting_financials_white-01.svg2",
  "icon_reports-01.svg2",
  "icon_responders-01.svg2",
  "icon_save-01.svg2",
  "icon_shorttext-01.svg2",
  "icon_status-01.svg2",
  "icon_voice_tel-01.svg2",
  "icon_warning-01.svg2",
  "icon_weather_header_c-01.svg2",
  "icon_weather_header_dark.svg2",
  "icon_weather_header.svg2",
  "icon_whatsapp-01.svg2",
  "import_side-01.svg2",
  "import-01.svg2",
  "inbound_numbers.svg2",
  "incident_report.svg2",
  "info-01.svg2",
  "info.svg2",
  "interactions_nav.svg2",
  "interactions.svg2",
  "invoice_history.svg2",
  "invoicing.svg2",
  "knowledgebase-01.svg2",
  "ldap-01.svg2",
  "library_broadcast.svg2",
  "library_documents.svg2",
  "library_logic.svg2",
  "library_puzzle.svg2",
  "lightning.svg2",
  "live_chat.svg2",
  "logout.svg2",
  "mapping.svg2",
  "marketing_fields.svg2",
  "masking.svg2",
  "menu.svg2",
  "message_recipients.svg2",
  "messages_processed-01.svg2",
  "messages_processed.svg2",
  "messages-01.svg2",
  "messages.svg2",
  "messenger.svg2",
  "monitoring/alerts_notifications-01.svg2",
  "monitoring/check_tick-01.svg2",
  "monitoring/configuration-01.svg2",
  "monitoring/icon_ping (1).svg2",
  "monitoring/industries/industry_construction-01.svg2",
  "monitoring/map_view-01.svg2",
  "monitoring/monitor_types/icon_alert.svg2",
  "monitoring/monitor_types/mon_environmental_conditions-01.svg2",
  "monitoring/monitor_types/mon_remote_devices-01.svg2",
  "monitoring/monitor_types/mon_weather.svg2",
  "monitoring/monitor_types/mon_welfare-01.svg2",
  "monitoring/monitoring-01.svg2",
  "monitoring/monitors_overview-01.svg2",
  "monitoring/save-01.svg2",
  "monitoring/select_workflow-01.svg2",
  "monitoring/setup-01.svg2",
  "monitoring/view_manage_monitors-01.svg2",
  "movable-01.svg2",
  "movable.svg2",
  "nav_billing.svg2",
  "nav_contacts.svg2",
  "nav_dashboard.svg2",
  "nav_monitoring-01.svg2",
  "nav_reports.svg2",
  "nav_settings.svg2",
  "nav_templates.svg2",
  "num-status.svg2",
  "num-validation.svg2",
  "nylas.svg2",
  "omni-channel.svg2",
  "opt-in-out.svg2",
  "originator.svg2",
  "overview-01.svg2",
  "payment_methods.svg2",
  "personal_details.svg2",
  "plus.svg2",
  "precipitation.svg2",
  "prepaid.svg2",
  "pressure.svg2",
  "preview.svg2",
  "print.svg2",
  "process_reports.svg2",
  "prod_api.svg2",
  "prod_boomlogic.svg2",
  "prod_broadcast.svg2",
  "prod_inbound.svg2",
  "profile_fields.svg2",
  "rain.svg2",
  "realtime_reporting.svg2",
  "redo.svg2",
  "reporting_analytical.svg2",
  "reporting_system.svg2",
  "reporting-01.svg2",
  "reports_export.svg2",
  "reports_generate.svg2",
  "reports_saved.svg2",
  "required_fields.svg2",
  "satisfaction_survey.svg2",
  "save.svg2",
  "schedule_send.svg2",
  "scheduling.svg2",
  "search.svg2",
  "secure_lock..svg2",
  "security.svg2",
  "self-manage.svg2",
  "send.svg2",
  "service_entries.svg2",
  "settings.svg2",
  "shortlink.svg2",
  "shortlink2.svg2",
  "sla.svg2",
  "sms_text.svg2",
  "snow.svg2",
  "social_fb-01.svg2",
  "social_fb.svg2",
  "social_hours-01.svg2",
  "social_li-01.svg2",
  "social_li.svg2",
  "social_x-01.svg2",
  "social_x.svg2",
  "social-hours.svg2",
  "status.svg2",
  "support_ticket.svg2",
  "switch_refresh.svg2",
  "system_usage-01.svg2",
  "system_usage.svg2",
  "temperature.svg2",
  "template_account.svg2",
  "template_boomerang.svg2",
  "template_helper.svg2",
  "template_rec.svg2",
  "tick_circled.svg2",
  "tick_list.svg2",
  "tick.svg2",
  "tiket_reporting.svg2",
  "timezones.svg2",
  "undo.svg2",
  "unicode.svg2",
  "unrec-response.svg2",
  "upgrades.svg2",
  "upload_file-01.svg2",
  "upload.svg2",
  "user_group-01.svg2",
  "user_group.svg2",
  "uv.svg2",
  "visibility.svg2",
  "weather_conditions_icons/clear_sky-01.svg2",
  "weather_conditions_icons/cloudy-01.svg2",
  "weather_conditions_icons/drizzle-01.svg2",
  "weather_conditions_icons/fog-01.svg2",
  "weather_conditions_icons/gust-01.svg2",
  "weather_conditions_icons/heavy_rain_shower-01.svg2",
  "weather_conditions_icons/heavy_rain-01.svg2",
  "weather_conditions_icons/heavy_snow_shower-01.svg2",
  "weather_conditions_icons/heavy_snow-01.svg2",
  "weather_conditions_icons/humidity-01.svg2",
  "weather_conditions_icons/light_rain_shower-01.svg2",
  "weather_conditions_icons/light_rain-01.svg2",
  "weather_conditions_icons/light_snow_shower-01.svg2",
  "weather_conditions_icons/light_snow-01.svg2",
  "weather_conditions_icons/max_screen_temp-01.svg2",
  "weather_conditions_icons/min_screen_temp-01.svg2",
  "weather_conditions_icons/mist-01.svg2",
  "weather_conditions_icons/overcast-01.svg2",
  "weather_conditions_icons/partly_cloudy-01.svg2",
  "weather_conditions_icons/probability_hail-01.svg2",
  "weather_conditions_icons/probability_of_snow_visibility-01.svg2",
  "weather_conditions_icons/probability_precipitation-01.svg2",
  "weather_conditions_icons/probability_sferics-01.svg2",
  "weather_conditions_icons/sea-level-pressure-01.svg2",
  "weather_conditions_icons/significant_weather-01.svg2",
  "weather_conditions_icons/sleet_shower-01.svg2",
  "weather_conditions_icons/sleet-01.svg2",
  "weather_conditions_icons/sunny-01.svg2",
  "weather_conditions_icons/thunder_shower-01.svg2",
  "weather_conditions_icons/thunder-01.svg2",
  "weather_conditions_icons/uv-index-01.svg2",
  "weather_conditions_icons/weather_conditions_alt.svg2",
  "weather_conditions_icons/weather_conditions.svg2",
  "weather_conditions_icons/wind_direction_old.svg2",
  "weather_conditions_icons/wind_direction.svg2",
  "weather_conditions_icons/wind_speed-01_old.svg2",
  "weather_conditions_icons/wind_speed-01.svg2",
  "web-forms.svg2",
  "whatsapp.svg2",
  "wind_direction.svg2",
  "workflows.svg2",
  "xls_files-01.svg2",
] as const;

export type BoomIconName = typeof boomIconNameOptions[number];

export type BoomIconNameOption = {
  label: string;
  value: BoomIconName | (string & {});
};

export const getBoomIconNameOptionLabel = (value: string) => {
  return value?.split("/").pop()?.split(".")[0].replace(/[-_]+/g, " ") || value;
};

export const loadBoomIconNameOptions = (
  search = "",
  prevOptions: BoomIconNameOption[] = []
) => {
  const normalizedSearch = search.toLowerCase();
  const filtered = boomIconNameOptions.filter((iconName) =>
    getBoomIconNameOptionLabel(iconName)
      .toLowerCase()
      .includes(normalizedSearch)
  );

  return {
    options: filtered
      .slice(prevOptions.length, prevOptions.length + 10)
      .map((iconName) => ({
        label: getBoomIconNameOptionLabel(iconName),
        value: iconName,
      })),
    hasMore: filtered.length > prevOptions.length + 10,
  };
};

export const formatBoomIconNameOptionLabel = (option: BoomIconNameOption) => {
  return React.createElement(
    "div",
    { className: "d-flex align-items-center gap-2" },
    React.createElement(BoomIcon, {
      icon: option.value,
      width: 18,
      className: "flex-shrink-0",
    }),
    option.label
  );
};

export const getBoomIconNameValueLabels = (values?: string[]) => {
  return (
    values &&
    values.map((value) => ({
      label: getBoomIconNameOptionLabel(value),
      value,
    }))
  );
};
